import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { useSchoolShift } from '../hooks/useSchoolShift';
import { darkTheme } from './Constants'; // Certifica-te de que este path está correto no teu projeto
import SchoolShiftDeleteModal from './SchoolShiftDeleteModal';
import SchoolShiftEditor from './SchoolShiftEditor';
import SchoolShiftSidebar from './SchoolShiftSidebar';

const SchoolShiftList = () => {
  const { state, actions, form } = useSchoolShift();

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box 
        sx={{ 
          display: 'flex', 
          height: '100vh', 
          bgcolor: 'background.default', 
          p: { xs: 1, md: 2 }, 
          gap: { xs: 1, md: 2 } 
        }}
      >
        <SchoolShiftSidebar state={state} actions={actions} />
        <SchoolShiftEditor state={state} actions={actions} form={form} />
      </Box>
      <SchoolShiftDeleteModal state={state} actions={actions} />
    </ThemeProvider>
  );
};

export default SchoolShiftList;